import api from './api';

/**
 * Fetch controller templates with optional category filter
 * @param {string|null} category - Category filter (e.g., 'Controllers')
 * @returns {Promise<Object>} API response with controller templates
 */
export async function fetchControllerTemplates(category = null) {
  try {
    const params = {};
    if (category) {
      params.category = category;
    }

    const response = await api.get('v2/controller-templates', params);
    return response;
  } catch (error) {
    console.error('Error fetching controller templates:', error);
    throw error;
  }
}

/**
 * Fetch a single controller template by ID
 * @param {number} id - Controller template ID
 * @returns {Promise<Object>} Controller template data
 */
export async function fetchControllerTemplate(id) {
  try {
    const response = await api.get(`v2/controller-templates/${id}`);
    return response;
  } catch (error) {
    console.error('Error fetching controller template:', error);
    throw error;
  }
}

/**
 * Update a controller template
 * @param {number} id - Controller template ID
 * @param {Object} data - Template data to update
 * @returns {Promise<Object>} Updated controller template
 */
export async function updateControllerTemplate(id, data) {
  try {
    const response = await api.put(`v2/controller-templates/${id}`, data);
    return response;
  } catch (error) {
    console.error('Error updating controller template:', error);
    throw error;
  }
}
